module.exports = __webpack_public_path__ + "img/check.95bd40c6.svg";